import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import styles from "./Card.module.styl";

function Card({ padding, borderRadius, borderColor, children, className, name, onClick }) {
    const classes = cx(
        styles.card,
        styles["padding_" + padding],
        styles["borderRadius_" + borderRadius],
        borderColor && styles["borderColor_" + borderColor],
        className,
    );

    return (
        <div className={classes} data-test-name={name} onClick={onClick}>
            {children}
        </div>
    );
}

Card.propTypes = {
    padding: PropTypes.oneOf(["none", "small", "big"]),
    borderRadius: PropTypes.oneOf(["small", "big", "giant"]),
    borderColor: PropTypes.oneOf(["green", "red", "yellow", "gray"]),
    className: PropTypes.string,
    name: PropTypes.string,
    onClick: PropTypes.func,
};

Card.defaultProps = {
    padding: "small",
    borderRadius: "big",
    className: "",
};

export default Card;
